import { defineNuxtPlugin, useRoute, useNuxtApp } from "#app"

export default defineNuxtPlugin(() => {
  const route = useRoute()

  if (route.query.preview) {
    useNuxtApp().payload.preview = true
  }
})
